export enum Theme {
    DEFAULT_BLUE = 'default_blue',
    DVG_PRIMARY = 'DVG',
    DVB_PRIMARY = 'DVB'
}